import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { OTPChallenge } from './OTPChallenge';
import SessionStore from '../../stores/SessionStore';
import LoaderComponent from '../common/LoaderComponent';

export class StepUpWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: SessionStore.isStepUpChallengeLoading(),
    };
  }

  componentDidMount() {
    SessionStore.addChangeListener(this.onSessionStoreChange);
  }

  componentWillUnmount() {
    SessionStore.removeChangeListener(this.onSessionStoreChange);
  }

  onSessionStoreChange = () => {
    const { handleSuccess } = this.props;
    if (SessionStore.isStepUpCompleted()) {
      handleSuccess();
    }

    if (!SessionStore.isStepUpMode()) {
      return;
    }

    this.setState({
      isLoading: SessionStore.isStepUpChallengeLoading(),
    });
  };

  render() {
    const { content, handleCancel } = this.props;
    const { isLoading } = this.state;
    if (isLoading) {
      return <LoaderComponent type="large" />;
    }

    return <OTPChallenge content={content} handleCancel={handleCancel} />;
  }
}

StepUpWrapper.propTypes = {
  content: PropTypes.object.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};
